// @flow
import * as React from "react";
import {reisy, use} from "reisy";
import Navigation from "../navigation/index.js";
import InlineLoader from "../components/inline-loader.js";

export const styles = reisy`
@namespace LoadingScreen;

JackInTheBox: $Settings.JackInTheBox;

Loading {
	@extends Helpers.Fullscreen;
}
Contain {
	@extends Helpers.Contain;
}

Content {
	max-width: 300px;
	min-height: 100vh;

	$(InlineLoader.Loader) {
		background: transparent;
	}

	$(InlineLoader.Spinner) {
		border-color: rgba(0, 0, 0, 0.2);
		border-left-color: #000;
	}
}

`;


const LoadingScreen = () => (
	<div {...use(styles.Loading, styles.JackInTheBox && styles.Contain)}>
		<div {...use(styles.Content)}>
			<InlineLoader />
		</div>
	</div>
);
export default LoadingScreen;



// WEBPACK FOOTER //
// ./lib/screens/loading.js